import { token } from "@amzn/stencil-design-tokens/js/web/utils";
import { H3 } from "@amzn/stencil-react-components/text";
import styled from "@emotion/styled";

/**
 * A styled H3 heading that shows interactive behavior.
 */
export const StyledClickableH3 = styled(H3)({
  cursor: "pointer",
  color: token("color.link.primary-default"),
  ":hover": {
    color: token("color.link.primary-hover"),
  },
});
